exports = module.exports = require("../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.line[data-v-02aed6dc] {\n  animation: linePencil .8s infinite linear;\n}\n@keyframes linePencil {\n0% {\n    transform: translateY(0);\n}\n100% {\n    transform: translateY(-150px);\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-02aed6dc","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./~/vue-loading-spinner/src/components/Pencil.vue
// module id = 467
// module chunks = 0